module.exports = __webpack_public_path__ + "img/geep-logo-no-bg.0493d2fb.png";